import { Link as MuiLink } from '@mui/material';
import { LinkProps } from '@mui/material/Link';

export const Link = (props: LinkProps) => <MuiLink {...props} />;

export default Link;
